// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vue-component.asset{margin-bottom:1.5em!important}.vue-component.asset>*{margin:.25em 0}.vue-component.asset .actions>.action{padding:.5em}.vue-component.asset h4{font-size:1.1em}.vue-component.asset h4>.roles{font-size:.95em;margin-left:.3em}.vue-component.asset h5{font-size:1.1em;font-weight:700;margin:.5em 0}.vue-component.asset .metadata{font-size:.9em}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
